/**
 * Format number with thousand separator (dot)
 * @param {number|string} value - The number to format
 * @returns {string} - Formatted number string
 */
export const formatNumberWithSeparator = (value) => {
  if (value === null || value === undefined || value === '') return '';
  
  // Convert to string and remove any existing separators
  const cleanValue = String(value).replace(/\./g, '');
  
  // If not a valid number, return original
  if (isNaN(cleanValue)) return value;
  
  // Format with dot as thousand separator
  return Number(cleanValue).toLocaleString('id-ID');
};

/**
 * Parse formatted number string to number
 * @param {string} value - The formatted string
 * @returns {number} - Parsed number
 */
export const parseNumberFromSeparator = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  
  // Remove dots (thousand separators)
  const cleanValue = String(value).replace(/\./g, '');
  
  const parsed = Number(cleanValue);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Handle onChange for formatted number input
 * @param {Event} e - Input change event
 * @param {Function} setter - State setter function
 */
export const handleNumberInputChange = (e, setter) => {
  const rawValue = e.target.value.replace(/\./g, '');
  
  // Only allow numbers
  if (rawValue === '' || /^\d+$/.test(rawValue)) {
    setter(rawValue);
  }
};
